import Timeline from './timeline';

export default Timeline;

export { TimelineProps, TimelineItemProps } from './interface';
